import { render, staticRenderFns } from "./kanBanManage.vue?vue&type=template&id=3d652e94&scoped=true&"
import script from "./kanBanManage.vue?vue&type=script&lang=js&"
export * from "./kanBanManage.vue?vue&type=script&lang=js&"
import style0 from "./kanBanManage.vue?vue&type=style&index=0&id=3d652e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d652e94",
  null
  
)

export default component.exports